<template>
  <div class="annotate-bar">
    <div class="annotate-tools-widget annotate-tools-widget-ls">
      <toolbar-button @click.native="setTool('select')" v-if="tools.includes('select')" :selected="toolSelected === 'select'" toolname="Select">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z" />
        </svg>
      </toolbar-button>

      <toolbar-button @click.native="setTool('laser')" v-if="tools.includes('laser')" :selected="toolSelected === 'laser'" toolname="Laser Pointer">
        <svg class="toolbarIcon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="#3e4c59" clip-rule="evenodd" d="M18.3451 12.6456C18.7084 10.5575 18.2704 8.33053 16.946 6.46603C14.3128 2.759 9.17305 1.88848 5.46603 4.52166C1.759 7.15485 0.888479 12.2946 3.52166 16.0016C5.71282 19.0864 9.63963 20.207 13.0323 18.979L12.1671 16.9519C10.9493 17.3803 9.62538 17.4101 8.38768 17.0349C7.10634 16.6464 5.98917 15.8457 5.20976 14.757C4.43035 13.6683 4.03234 12.3526 4.07758 11.0145C4.12281 9.6763 4.60875 8.39055 5.4599 7.35697C6.31104 6.3234 7.47973 5.59988 8.78438 5.29884C10.089 4.9978 11.4566 5.1361 12.6745 5.69224C13.8925 6.24838 14.8927 7.19123 15.5197 8.37428C16.1277 9.52165 16.3518 10.8326 16.1608 12.1149L18.3451 12.6456ZM14.4763 11.7057C14.5739 10.837 14.4078 9.95703 13.9967 9.18139C13.5476 8.33391 12.8311 7.6585 11.9586 7.26011C11.0861 6.86172 10.1065 6.76265 9.1719 6.9783C8.23732 7.19395 7.40013 7.71224 6.79041 8.45264C6.18069 9.19305 5.83258 10.1141 5.80018 11.0727C5.76777 12.0313 6.05289 12.9737 6.61122 13.7536C7.16955 14.5335 7.96983 15.1072 8.88772 15.3854C9.73838 15.6433 10.6459 15.6341 11.4886 15.3619L10.8945 13.9699C10.4067 14.0835 9.89509 14.0635 9.41453 13.909C8.834 13.7225 8.331 13.35 7.98315 12.8492C7.63529 12.3484 7.4619 11.747 7.48974 11.1379C7.51758 10.5287 7.74509 9.94567 8.13718 9.47866C8.52926 9.01166 9.06413 8.68665 9.65926 8.55379C10.2544 8.42093 10.8767 8.4876 11.4302 8.74351C11.9836 8.99942 12.4375 9.43035 12.7218 9.96981C12.9477 10.3985 13.0565 10.8768 13.0405 11.3568L14.4763 11.7057ZM11.9863 11.1007C11.965 10.8775 11.9005 10.6592 11.7946 10.4584C11.6176 10.1225 11.335 9.85411 10.9903 9.69476C10.6457 9.5354 10.2582 9.49389 9.8876 9.57662C9.51702 9.65935 9.18396 9.86173 8.93982 10.1525C8.69567 10.4433 8.554 10.8064 8.53666 11.1857C8.51933 11.565 8.62729 11.9395 8.8439 12.2513C9.06051 12.5632 9.37372 12.7951 9.73521 12.9113C9.97453 12.9882 10.2262 13.0116 10.4728 12.9817L9.88555 11.6057C9.70534 11.1834 10.3236 10.6762 10.8175 10.8167L11.9863 11.1007Z"/>
          <path fill="#3e4c59" d="M21.075 15.3925L18.496 16.4932L20.9553 18.496C21.1262 18.6346 21.1038 18.8814 20.9201 19.0496L19.8985 19.9665C19.7081 20.1376 19.4212 20.1574 19.2525 20.0242L16.9164 18.1228L15.5317 20.7144C15.3472 21.0597 14.8177 21.0802 14.6915 20.7844L11.2098 12.6263C11.0769 12.3149 11.4964 11.9564 11.8417 12.068L21.1266 14.6715C21.4961 14.7648 21.452 15.2316 21.075 15.3925Z"/>
        </svg>
      </toolbar-button>

      <div class="splitter"></div>

      <toolbar-button @click.native="setTool('pen')" v-if="tools.includes('pen')" :selected="toolSelected === 'pen'" toolname="Pen">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M20.84 5.25C21.06 5.03 21.06 4.67 20.84 4.46L19.54 3.16C19.33 2.95 18.97 2.95 18.76 3.16L17.74 4.18L19.82 6.26M11 10.92V13H13.08L19.23 6.85L17.15 4.77L11 10.92Z" />
        </svg>
      </toolbar-button> 

      <toolbar-button @click.native="setTool('line')" v-if="tools.includes('line')" :selected="toolSelected === 'line'" toolname="Line">
        <svg class="toolbarIcon" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="m4.3664 17.859 14.78-12.686" fill="none" stroke="#000" stroke-width="1.0183px"/>
          <rect x="18.247" y="3.972" width="1.8408" height="2.0151" fill-rule="evenodd" stroke-width="1.1963"/>
          <rect x="3.271" y="17.14" width="1.8408" height="2.0151" fill-rule="evenodd" stroke-width="1.1963"/>
        </svg>
      </toolbar-button> 

      <toolbar-button @click.native="setTool('rect')" v-if="tools.includes('rect')" :selected="toolSelected === 'rect'" toolname="Rectangle">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M18,18H6V6H18M18,4H6A2,2 0 0,0 4,6V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18V6C20,4.89 19.1,4 18,4Z" />
        </svg>
      </toolbar-button> 

      <toolbar-button @click.native="setTool('ellipse')" v-if="tools.includes('ellipse')" :selected="toolSelected === 'ellipse'" toolname="Ellipse">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
        </svg>
      </toolbar-button> 

      <toolbar-button @click.native="setTool('text')" v-if="tools.includes('text')" :selected="toolSelected === 'text'" toolname="Text">
        <svg xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0V0z" fill="none"/>
          <path  fill="#3e4c59" d="M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"/>
        </svg>
      </toolbar-button> 

      <div class="splitter"></div>

      <toolbar-button @click.native="toggleFormatter" toolname="Properties" style="margin: 3px 0 4px 12px">
        <div class="toolbarIcon" style="box-sizing: border-box; display:flex; align-items: center; justify-content:center" :style="{ border: `${thickness / 2}px solid ${lineColor}`, background: fillColor}">
          <svg style="width:24px;height:24px;" viewBox="0 0 24 24">
            <path fill="#3e4c59" d="M17.5,12A1.5,1.5 0 0,1 16,10.5A1.5,1.5 0 0,1 17.5,9A1.5,1.5 0 0,1 19,10.5A1.5,1.5 0 0,1 17.5,12M14.5,8A1.5,1.5 0 0,1 13,6.5A1.5,1.5 0 0,1 14.5,5A1.5,1.5 0 0,1 16,6.5A1.5,1.5 0 0,1 14.5,8M9.5,8A1.5,1.5 0 0,1 8,6.5A1.5,1.5 0 0,1 9.5,5A1.5,1.5 0 0,1 11,6.5A1.5,1.5 0 0,1 9.5,8M6.5,12A1.5,1.5 0 0,1 5,10.5A1.5,1.5 0 0,1 6.5,9A1.5,1.5 0 0,1 8,10.5A1.5,1.5 0 0,1 6.5,12M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A1.5,1.5 0 0,0 13.5,19.5C13.5,19.11 13.35,18.76 13.11,18.5C12.88,18.23 12.73,17.88 12.73,17.5A1.5,1.5 0 0,1 14.23,16H16A5,5 0 0,0 21,11C21,6.58 16.97,3 12,3Z" />
          </svg>
        </div>
      </toolbar-button>

      <toolbar-button @click.native="confirmDelete = !confirmDelete" toolname="Clear Whiteboard" :confirm="confirmDelete" @dialogClose="confirmDelete = false">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M15,16H19V18H15V16M15,8H22V10H15V8M15,12H21V14H15V12M3,18A2,2 0 0,0 5,20H11A2,2 0 0,0 13,18V8H3V18M14,5H11L10,4H6L5,5H2V7H14V5Z" />
        </svg>
        <template v-slot:dialog>
          <div style="padding: 5px 0px 5px 9px; display:flex; align-items: start; flex-direction: column; cursor:default" @click.stop="">
            <div style="display:flex; align-items: center">
              <div style="padding-top:3px">Confirm Clear Whiteboard</div>
              <div style="margin-left: 10px; background-color: #eee;  border-radius: 2px; height: 30px;">
                <svg class="confirm-button confirm-tick" @click.stop="deleteAllObjects" viewBox="0 0 24 24">
                  <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                </svg>
                <svg class="confirm-button confirm-close" @click.stop="confirmDelete = false" viewBox="0 0 24 24">
                  <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
              </div>
            </div>
            <div style="display: flex; align-items: inherit; justify-content: right; margin-top: 3px; margin-right: 2px;">
              <input type="checkbox" id="clear-permanent" style="cursor:pointer" v-model="clearPermanent" /> <label for="clear-permanent">Clear History</label> 
            </div>
          </div>
        </template>
      </toolbar-button> 

      <toolbar-button @click.native="undo" toolname="Undo" :disabled="!canUndo">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z" />
        </svg>
      </toolbar-button> 

      <toolbar-button @click.native="redo" toolname="Redo" :disabled="!canRedo">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z" />
        </svg>
      </toolbar-button>
      <div class="splitter"></div>

      <toolbar-button @click.native="download" toolname="Download">
        <svg class="toolbarIcon" viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
        </svg>
      </toolbar-button>
    </div>
      <div class="formatter" :style="{ right: formatterOpen ? '53px' : '-150px'}">   
        <div class="format-header">{{showFontOptions ? 'Font' : (toolSelected === 'laser') ? 'Laser' : 'Line'}} Color</div>
        <div class="color-pick">
          <div class="option-block" style="border: 2px solid #000; background-color: #000; " @click="lineColor='#000'" :class="{ selectedOption: lineColor === '#000'}">
          </div>
          <div class="option-block" style="border: 2px solid rgb(230, 54, 46); background-color: rgb(230, 54, 46);" @click="lineColor='#e6362e'" :class="{ selectedOption: lineColor === '#e6362e'}">
          </div>
          <div class="option-block" style="border: 2px solid rgb(59, 193, 35); background-color: rgb(59, 193, 35);" @click="lineColor='#3bc123'" :class="{ selectedOption: lineColor === '#3bc123'}">
          </div>
          <div class="option-block" style="border: 2px solid rgb(58, 117, 224); background-color: rgb(58, 117, 224);" @click="lineColor='#3a75e0'" :class="{ selectedOption: lineColor === '#3a75e0'}">
          </div>
        </div>

        <div v-if="showFillColorOptions">
          <div class="format-header"><div>Fill Color</div><div style="flex-grow: 1"></div><div style="color:#5650d7" @click="fillColor='transparent'">clear</div></div>
          <div class="color-pick">
            <div class="option-block" style="border: 2px solid rgba(209, 220, 39, 0.33); background-color: rgba(209, 220, 39, 0.33);" @click="fillColor='#ebeeb8'" :class="{ selectedOption: fillColor === '#ebeeb8'}">
            </div>
            <div class="option-block" style="border: 2px solid rgb(230, 54, 46, .33); background-color: rgb(230, 54, 46, .33); " @click="fillColor='#f2b8ba'" :class="{ selectedOption: fillColor === '#f2b8ba'}">
            </div>
            <div class="option-block" style="border: 2px solid rgb(59, 193, 35, .33); background-color: rgb(59, 193, 35, .33);" @click="fillColor='#b9e6b7'" :class="{ selectedOption: fillColor === '#b9e6b7'}">
            </div>
            <div class="option-block" style="border: 2px solid rgb(58, 117, 224, .33); background-color: rgb(58, 117, 224, .33); " @click="fillColor='#b9cdf5'" :class="{ selectedOption: fillColor === '#b9cdf5'}">
            </div>
          </div>
        </div>
        <div v-if="!showFontOptions && showLineThickness">
        <div class="format-header">Line Thickness</div>
          <div class="line-thickness">
            <div class="option-block"  @click="thickness=2" :class="{ selectedOption: thickness === 2}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
                <path d="m 4.57,18.73 a 0.5,0.5 0 0 0 0,0.7 0.5,0.5 0 0 0 0.71,0 L 19.42,5.28 a 0.5,0.5 0 0 0 0,-0.71 0.5,0.5 0 0 0 -0.71,0 l 0,0 L 4.58,18.72 a 0.5,0.5 0 0 0 0,0 z" />
              </svg>
            </div>
            <div class="option-block" @click="thickness=4" :class="{ selectedOption: thickness === 4}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
                <path d="m 4.58,18 a 1,1 0 0 0 0,1.41 1,1 0 0 0 1.41,0 L 19.42,6 a 1,1 0 0 0 0,-1.41 1,1 0 0 0 -1.41,0 z" />
              </svg>
            </div>
            <div class="option-block" @click="thickness=6" :class="{ selectedOption: thickness === 6}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
                <path d="m 4.5753788,17.303301 a 1.5,1.5 0 0 0 0,2.12132 1.5,1.5 0 0 0 2.1213203,0 L 19.424621,6.6966991 a 1.5,1.5 0 0 0 0,-2.1213203 1.5,1.5 0 0 0 -2.12132,0 z" />
              </svg>
            </div>
            <div class="option-block" @click="thickness=8" :class="{ selectedOption: thickness === 8}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
                <path d="m 4.54,16.63 a 2,2 0 0 0 0,2.79 2,2 0 0 0 2.83,0 L 19.42,7.4 a 2,2 0 0 0 0,-2.83 2,2 0 0 0 -2.83,0 l -0.03535,0.035355 -12,12 a 2,2 0 0 0 0,0 z" />
              </svg>
            </div>
          </div>
        </div>
        <div v-if="showFontOptions">
          <div class="format-header">Font</div>

          <div class="font-options">
            <!-- <div style="height:30px; width:30px; background-color: #fff; border-radius:3px; margin:2px">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="#3e4c59" d="M5.12,14L7.5,7.67L9.87,14M6.5,5L1,19H3.25L4.37,16H10.62L11.75,19H14L8.5,5H6.5M18,7L13,12.07L14.41,13.5L17,10.9V17H19V10.9L21.59,13.5L23,12.07L18,7Z" />
              </svg>
            </div>
            <div style="height:30px; width:30px; background-color: #fff border-radius:3px; margin:2px">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="#3e4c59" d="M5.12,14L7.5,7.67L9.87,14M6.5,5L1,19H3.25L4.37,16H10.62L11.75,19H14L8.5,5H6.5M18,17L23,11.93L21.59,10.5L19,13.1V7H17V13.1L14.41,10.5L13,11.93L18,17Z" />
              </svg>
            </div> -->
            <div class="option-block" @click="bold=!bold" :class="{ selectedOption: bold}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
                <path fill="#3e4c59" d="M13.5,15.5H10V12.5H13.5A1.5,1.5 0 0,1 15,14A1.5,1.5 0 0,1 13.5,15.5M10,6.5H13A1.5,1.5 0 0,1 14.5,8A1.5,1.5 0 0,1 13,9.5H10M15.6,10.79C16.57,10.11 17.25,9 17.25,8C17.25,5.74 15.5,4 13.25,4H7V18H14.04C16.14,18 17.75,16.3 17.75,14.21C17.75,12.69 16.89,11.39 15.6,10.79Z" />
              </svg>
            </div>
            <div class="option-block" @click="underline=!underline" :class="{ selectedOption: underline}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
                <path fill="#3e4c59" d="M5,21H19V19H5V21M12,17A6,6 0 0,0 18,11V3H15.5V11A3.5,3.5 0 0,1 12,14.5A3.5,3.5 0 0,1 8.5,11V3H6V11A6,6 0 0,0 12,17Z" />
              </svg>
            </div>

            <div class="option-block" @click="strikethrough=!strikethrough" :class="{ selectedOption: strikethrough}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
              <path fill="#3e4c59" d="M3,14H21V12H3M5,4V7H10V10H14V7H19V4M10,19H14V16H10V19Z" />
            </svg>
            </div>

            <div class="option-block" @click="italic=!italic" :class="{ selectedOption: italic}">
              <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
                <path fill="#3e4c59" d="M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z" />
              </svg>
            </div>
          </div>
        </div>        
      </div>
      <a ref="downloadLink" download="myImage.jpg" href="" style="display:none"></a>
  </div>
</template>

<script>
  import toolbarButton from './toolbar-button'
  const { getWhiteboard } = require('@/whiteboard')
  let whiteboard
  export default {
    components: {
      toolbarButton,
    },
    data() {
      return {
        tools: [],
        toolSelected: '',
        showFormatter: false,

        thicknessValue: 2,
        lineColorValue: '#000',
        fillColorValue: 'transparent',

        laserColor: '#e6362e',

        underlineValue: false,
        boldValue: false,
        italicValue: false,
        strikethroughValue: false,
        
        canUndo: false,
        canRedo: false,

        confirmDelete: false,
        clearPermanent: false,
      }
    },
    mounted: function() {
      whiteboard = getWhiteboard({canvasId: 'annotation-canvas'});
      this.tools = whiteboard.getToolNames();
      whiteboard.on('selectionChanged', this.selectionChanged);
      whiteboard.on('commandBufferEvent', e=> {
        this.canUndo = e.status.canUndo
        this.canRedo = e.status.canRedo
      });
       whiteboard.on('ready', () => {
        this.setTool('pen')
      })
      this.clearPermanent = window.localStorage.getItem('wb_clearPermanent') === 'true';
    },
    watch: {
      clearPermanent (val) {
        window.localStorage.setItem('wb_clearPermanent', val)
      }
    },
    computed: {
      thickness: {
        set (val) {
          this.thicknessValue = val
          this.setToolProperties(this.toolSelected)
        },
        get () {
          return this.thicknessValue
        }
      },
      lineColor: {
        set (val) {
          if (this.toolSelected === 'laser') {
            this.laserColor = val
          } else {
            this.lineColorValue = val
          }
          this.setToolProperties(this.toolSelected)
        },
        get () {
          return (this.toolSelected === 'laser') ? this.laserColor : this.lineColorValue
        }
      },
      fillColor: {
        set (val) {
          this.fillColorValue = val
          this.setToolProperties(this.toolSelected)
        },
        get () {
          return this.fillColorValue
        }
      },
      underline: {
        set (val) {
          this.underlineValue = val
          this.setToolProperties(this.toolSelected)
        },
        get () {
          return this.underlineValue
        }
      },
      bold: {
        set (val) {
          this.boldValue = val
          this.setToolProperties(this.toolSelected)
        },
        get () {
          return this.boldValue
        }
      },
      italic: {
        set (val) {
          this.italicValue = val
          this.setToolProperties(this.toolSelected)
        },
        get () {
          return this.italicValue
        }
      },
      strikethrough: {
        set (val) {
          this.strikethroughValue = val
          this.setToolProperties(this.toolSelected)
        },
        get () {
          return this.strikethroughValue
        }
      },
      showFontOptions () {
        return this.toolSelected === 'text'
      },
      showFillColorOptions () {
        return (!['pen','line','laser'].includes(this.toolSelected))
      },
      showLineThickness () {
        return (!['laser'].includes(this.toolSelected))
      },      
      formatterOpen () {
        return this.showFormatter && (this.toolSelected !== 'select');
      },
      penProperties () {
        return {
          stroke: this.lineColor,
          strokeWidth: this.thickness
        }
      },
      lineProperties () {
        return {
          stroke: this.lineColor,
          strokeWidth: this.thickness
        }
      },
      rectProperties () {
        return {
          stroke: this.lineColor,
          strokeWidth: this.thickness,
          fill: this.fillColor
        }
      },
      ellipseProperties () {
        return {
          stroke: this.lineColor,
          strokeWidth: this.thickness,
          fill: this.fillColor
        }
      },
      laserProperties () {
        return {
          color: this.laserColor,
        }
      },
      textProperties () {
        return {
          textColor: this.lineColor,
          fill: this.fillColor,
          underline: this.underline,
          linethrough: this.strikethrough,
          fontWeight: this.bold ? 'bold' : '',
          fontStyle: this.italic ? 'italic' : ''
        }
      }
    },
    methods: {
      download () {
        let cachedTool = this.toolSelected;
        whiteboard.activateTool('laser')
        let datetime = new Date();

        let filename = [
          whiteboard.getTitle().replace(/[^a-z0-9_-]/gi, ''),
          '-whiteboard-',
          datetime.getFullYear(),
          '-',
          (datetime.getMonth() + 1).toString().padStart(2,'0'),
          '-',
          datetime.getDate().toString().padStart(2,'0'),
          '-at-',
          datetime.getHours().toString().padStart(2,'0'),
          '-',
          datetime.getMinutes().toString().padStart(2,'0'),
          '-',
          datetime.getSeconds().toString().padStart(2,'0'),
        ].join('')

        let dataURL = document.getElementById('annotation-canvas').toDataURL('image/png');
        this.$refs.downloadLink.download = filename + '.png';
        this.$refs.downloadLink.href = dataURL;
        this.$refs.downloadLink.click();
        whiteboard.activateTool(cachedTool)
      },
      deleteAllObjects () {
        if (this.clearPermanent) {
          whiteboard.clearHistory();
        } else {
          whiteboard.removeAllObjects();
        }
        this.confirmDelete = false
      },
      setToolProperties (tool) {
        whiteboard.setToolProperties(tool, this[this.toolSelected + 'Properties'])
      },
      selectionChanged (event) {
        if (event.idList.length > 0) {
          this.showFormatter = false
        }
      },
      toggleFormatter () {
        this.showFormatter = !this.showFormatter;
      },
      undo () {
        whiteboard.undo()
      },
      redo () {
        whiteboard.redo()
      },
      setTool (tool) {
        whiteboard.activateTool(tool)
        this.toolSelected = whiteboard.getActiveToolName();
        whiteboard.setToolProperties(this.toolSelected, this[this.toolSelected + 'Properties'])
      },
      removeObject () {
        whiteboard.removeSelectedObjects();
      }

    }
  }
</script>

<style scoped>
  .confirm-button {
    width:24px;
    height:24px; 
    padding:3px;
    cursor:pointer;
  }

  .confirm-close {
    margin-left: 5px;
  }

  .confirm-tick:hover {
    background-color: #00ff0044
  }

  .confirm-close:hover {
    background-color: #ff000044
  }

  .toolbarIcon {
    width:24px;
    height:24px;
  }

  .remove-button {
    margin-top: 15px;
    display:flex;
    align-items: center;
    font-size:.8rem;
    margin-left: 35px
  }

  .remove-button:hover {
    color:red
  }

  .option-block {
    height:30px;
    width:30px;
    border-radius:3px;
    margin:2px;
    border: 2px solid #fff;
  }

  .format-header {
    font-family: 'AzoSans-Bold';
    display: flex;
    padding: 13px 0;
    font-size: .7rem;
  }
  
  .selected {
    border: 1px solid #5650d7;
    border-right: 0px;
  }

  .selectedOption {
    border: 2px solid #5650d7 !important;
  }

  .color-pick, .line-thickness, .font-options {
    display: flex;
  }

  .annotate-bar {
    display: flex;
    align-items: center;
    pointer-events: none;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .annotate-tools-widget {
    position: absolute;
    transform: translate(0, -50%);
    left: 15px;
    z-index:2;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    background-color: #fff;
    pointer-events: auto;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .10);
    padding: 8px 0 8px;
  }

  .formatter {
    position: absolute;
    /* right: 65px; */
    z-index: 1;
    border-radius: 4px;
    padding: 20px;
    cursor: pointer;
    background-color: #fff;
    pointer-events: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    transition: right .2s linear
  }

  .annotate-tools-widget-ls {
    left: auto;
    right: -37px;
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
  }
  
  .splitter {
    height:1px;
    background: #ccc;
    margin: 3px 0
  }
</style>
